export default class TextZaehlen {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    // Update length output if needed.
    this.myGBtextLength = document.querySelector('#gbtext').value.length;
    // console.log(this.myGBtextLength);
    this.maxLng = 1000 - this.myGBtextLength;
    this.charsAmmount = document.querySelector('#gbanzeige');
    this.charsAmmount.innerHTML = this.maxLng;
    // console.log(this.el.id);
    this.el.onkeyup = function onkeyup() {
      this.myGBtextLength = document.querySelector('#gbtext').value.length;
      this.charsAmmount = document.querySelector('#gbanzeige');
      this.charsAmmount.innerHTML = 1000 - this.myGBtextLength;
    };
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/text_zaehlen.js